export const TargetPercentage = 90;

export interface IQueryObject {
  configId: IConfigId;
  configSessionId: string;
}

export interface IConfig {
  constants: IQueryConstants;
  id: IConfigId;
  inputs?: IQueryInputs[];
  ref: IQueryReference;
  sessionId?: string;
  data?: any[]; //eslint-disable-line
  currentData?: any[]; //eslint-disable-line
  historicalData?: any[]; //eslint-disable-line
  widgetConfig?: IWidgetConfig[];
}

export interface IWidgetConfig {
  title: string;
  type: string;
  options: any; //eslint-disable-line
}

export interface IQueryConstants {
  time_zone: string;
}

export enum IConfigId {
  TwampConfig = 'activetest-Twamp'
}

export enum IQueryNames {
  TwampQuery = 'activetest-Twamp_Query'
}

export interface IQueryInputs {
  ref: IQueryInput;
}

export interface IQueryInput {
  id: string;
  object: string;
}

export interface IQueryReference {
  uid: string;
  id?: number;
}
